export default __webpack_public_path__ + "static/media/LandingPageThree.92d546b7.png";